var AllCropContentWrapperContainer;
var ImageCropMainWrapper;
var ImageCropResultWrapper;
var UploadImageSuccessWrapper;

var IMGInputtedDisplayDiv;

var CropSectionAllElementContainer;
var CropResultImage;
var ImageCropperInput;
var FirstTimeUploadImageContainer;

var URLUploadedText;

var AddImageButton;
var ResetImageButton;
var RemoveImageButton;
var ApplyCropButton;

var ChangeCropImageAgainButton;
var SaveCroppedImageButton;

var WarningUploadImageContainer;
var WarningUploadImageText;

var cropper = '';

window.InstantiateEditPhotoPanel = function(thisuserid, tokenlogin)
{
  let BasicBlackBlocker = document.createElement("div");
  BasicBlackBlocker.className = "BasicBlackBlocker";
  document.body.append(BasicBlackBlocker);

  AllCropContentWrapperContainer = document.createElement("div");
  AllCropContentWrapperContainer.className = "FlexFullDisplayPanel";
  BasicBlackBlocker.append(AllCropContentWrapperContainer);

  // ---------- Image Crop Main Wrapper ----------
  ImageCropMainWrapper = document.createElement("div");
  ImageCropMainWrapper.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
  ImageCropMainWrapper.style.padding = "0";
  AllCropContentWrapperContainer.append(ImageCropMainWrapper);

  // Top bar
  let HotelDetailsHotelInformationMarginWrapper1 = document.createElement("div");
  HotelDetailsHotelInformationMarginWrapper1.className = "HotelDetailsHotelInformationMarginWrapper";
  ImageCropMainWrapper.append(HotelDetailsHotelInformationMarginWrapper1);

  let EditProfileTitle = document.createElement("p");
  EditProfileTitle.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
  EditProfileTitle.style.marginTop = "0";
  EditProfileTitle.style.marginBottom = "0";
  EditProfileTitle.innerHTML = window["EditProfileImageTxt" + window.CurrentCountryID];
  HotelDetailsHotelInformationMarginWrapper1.append(EditProfileTitle);

  let CloseButton1 = document.createElement("img");
  CloseButton1.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
  CloseButton1.className = "CloseButtonInsidePanel Selectable2";
  HotelDetailsHotelInformationMarginWrapper1.append(CloseButton1);

  // Profile image cropper container
  let ProfileImageCropperContainer = document.createElement("div");
  ProfileImageCropperContainer.className = "ProfileImageCropperContainer";
  ImageCropMainWrapper.append(ProfileImageCropperContainer);

  CropSectionAllElementContainer = document.createElement("div");
  CropSectionAllElementContainer.className = "DropOrCroppingImageContainer";
  ProfileImageCropperContainer.append(CropSectionAllElementContainer);

  let box2 = document.createElement("div");
  box2.className = "box-2";
  CropSectionAllElementContainer.append(box2);

  IMGInputtedDisplayDiv = document.createElement("div");
  IMGInputtedDisplayDiv.className = "result";
  box2.append(IMGInputtedDisplayDiv);

  FirstTimeUploadImageContainer = document.createElement("div");
  FirstTimeUploadImageContainer.className = "BlockerWithHoverableText";
  FirstTimeUploadImageContainer.onclick = function()
  {
    ChangeImageButtonClicked();
  }
  CropSectionAllElementContainer.append(FirstTimeUploadImageContainer);

  let BlockerText = document.createElement("p");
  BlockerText.className = "RoomUnavailableHeaderMessage InterMediumTextFont";
  BlockerText.innerHTML = window["ClickHereorDropImageFileHereTxt" + window.CurrentCountryID];
  FirstTimeUploadImageContainer.append(BlockerText);

  // Hidden file input
  let HiddenFileInputWrapper = document.createElement("div");
  HiddenFileInputWrapper.style.display = "none";
  ImageCropMainWrapper.append(HiddenFileInputWrapper);

  ImageCropperInput = document.createElement("input");
  ImageCropperInput.type = "file";
  ImageCropperInput.accept = ".jpg, .png, .jpeg";
  HiddenFileInputWrapper.append(ImageCropperInput);

  // Image URL display
  let OrangeWarningContainer = document.createElement("div");
  OrangeWarningContainer.className = "OrangeWarningContainer BasicRoundRadius HideOnMobile";
  ImageCropMainWrapper.append(OrangeWarningContainer);

  let OrangeWarningInner = document.createElement("div");
  OrangeWarningInner.style.width = "fit-content";
  OrangeWarningInner.style.height = "fit-content";
  OrangeWarningInner.style.margin = "auto";
  OrangeWarningInner.style.display = "flex";
  OrangeWarningContainer.append(OrangeWarningInner);

  let ImageUrlLabel = document.createElement("p");
  ImageUrlLabel.className = "LabelGreyHeaderSmallerText InterBoldTextFont";
  ImageUrlLabel.style.margin = "auto 0";
  ImageUrlLabel.innerHTML = window["ImageUrlTxt" + window.CurrentCountryID] + ": ";
  OrangeWarningInner.append(ImageUrlLabel);

  URLUploadedText = document.createElement("span");
  URLUploadedText.className = "InterRegularTextFont";
  URLUploadedText.innerHTML = "-";
  ImageUrlLabel.append(URLUploadedText);

  // Buttons row
  let ButtonWrapper1 = document.createElement("div");
  ButtonWrapper1.className = "MoreThanOneButtonFlexWrapper MarginTextUpDown";
  ButtonWrapper1.style.marginLeft = "auto";
  ButtonWrapper1.style.marginRight = "auto";
  ButtonWrapper1.style.marginBottom = "0";
  ImageCropMainWrapper.append(ButtonWrapper1);

  AddImageButton = document.createElement("button");
  AddImageButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
  AddImageButton.innerHTML = window["UploadImageTxt" + window.CurrentCountryID];
  ButtonWrapper1.append(AddImageButton);

  ResetImageButton = document.createElement("button");
  ResetImageButton.className = "BasicTextButton BasicBoxShadow ButtonInvalid SignInButtonTop Selectable";
  ResetImageButton.innerHTML = window["ResetTxt" + window.CurrentCountryID];
  ButtonWrapper1.append(ResetImageButton);

  RemoveImageButton = document.createElement("button");
  RemoveImageButton.className = "BasicTextButton BasicBoxShadow RedButton ButtonInvalid SignInButtonTop Selectable";
  RemoveImageButton.innerHTML = window["RemoveTxt" + window.CurrentCountryID];
  ButtonWrapper1.append(RemoveImageButton);

  // Description text
  let DescriptionText = document.createElement("p");
  DescriptionText.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
  DescriptionText.style.color = "#475467";
  DescriptionText.style.marginLeft = "auto";
  DescriptionText.style.marginRight = "auto";
  DescriptionText.innerHTML = window["DoneAdjustingMessageTxt" + window.CurrentCountryID];
  ImageCropMainWrapper.append(DescriptionText);

  // Apply Crop button
  ApplyCropButton = document.createElement("button");
  ApplyCropButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight ButtonInvalid PaddingExtendedButton Selectable";
  ApplyCropButton.style.width = "50%";
  ApplyCropButton.style.margin = "0 auto";
  ApplyCropButton.innerHTML = window["ApplyCropTxt" + window.CurrentCountryID];
  ImageCropMainWrapper.append(ApplyCropButton);

  // ================================= Crop Result Wrapper =================================

  ImageCropResultWrapper = document.createElement("div");
  ImageCropResultWrapper.className = "FlexContainerBaseAnimate CreatePasswordFlexWrapper";
  ImageCropResultWrapper.style.padding = "0";
  ImageCropResultWrapper.style.display = "none";
  AllCropContentWrapperContainer.append(ImageCropResultWrapper);

  let HotelDetailsHotelInformationMarginWrapper2 = document.createElement("div");
  HotelDetailsHotelInformationMarginWrapper2.className = "HotelDetailsHotelInformationMarginWrapper";
  ImageCropResultWrapper.append(HotelDetailsHotelInformationMarginWrapper2);

  let CropSuccessText = document.createElement("p");
  CropSuccessText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
  CropSuccessText.style.marginTop = "0";
  CropSuccessText.style.marginBottom = "0";
  CropSuccessText.innerHTML = window["CropSuccessHeaderTxt" + window.CurrentCountryID];
  HotelDetailsHotelInformationMarginWrapper2.append(CropSuccessText);

  let CloseButton2 = document.createElement("img");
  CloseButton2.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
  CloseButton2.className = "CloseButtonInsidePanel Selectable2";
  HotelDetailsHotelInformationMarginWrapper2.append(CloseButton2);

  WarningUploadImageContainer = document.createElement("div");
  WarningUploadImageContainer.className = "BasicRoundRadius MarginTextUpDown RedWarningContainer WarningTextMarginTop";
  WarningUploadImageContainer.style.display = "none";
  ImageCropResultWrapper.append(WarningUploadImageContainer);

  WarningUploadImageText = document.createElement("p");
  WarningUploadImageText.className = "InterMediumTextFont";
  WarningUploadImageText.innerHTML = window["ErrorUploadingImageMessTxt" + window.CurrentCountryID];
  WarningUploadImageContainer.append(WarningUploadImageText);
  

  let MyProfileCropResultImageContainer = document.createElement("div");
  MyProfileCropResultImageContainer.className = "MyProfileCropResultImageContainer";
  ImageCropResultWrapper.append(MyProfileCropResultImageContainer);

  let box2ImgResult = document.createElement("div");
  box2ImgResult.className = "box-2 img-result";
  box2ImgResult.style.width = "100%";
  box2ImgResult.style.height = "100%";
  MyProfileCropResultImageContainer.append(box2ImgResult);

  CropResultImage = document.createElement("img");
  CropResultImage.className = "cropped";
  CropResultImage.src = "";
  CropResultImage.alt = "";
  box2ImgResult.append(CropResultImage);

  // Save instructions
  let SaveInstructionText = document.createElement("p");
  SaveInstructionText.className = "DescriptionTextNotDisableable MarginTextUpDown InterRegularTextFont";
  SaveInstructionText.style.color = "#475467";
  SaveInstructionText.style.marginLeft = "auto";
  SaveInstructionText.style.marginRight = "auto";
  SaveInstructionText.innerHTML = window["ClickSaveButtonToApplyTxt" + window.CurrentCountryID];
  ImageCropResultWrapper.append(SaveInstructionText);

  // Buttons row for result
  let ButtonWrapper2 = document.createElement("div");
  ButtonWrapper2.className = "MoreThanOneButtonFlexWrapper";
  ButtonWrapper2.style.marginLeft = "auto";
  ButtonWrapper2.style.marginRight = "auto";
  ButtonWrapper2.style.marginBottom = "0";
  ImageCropResultWrapper.append(ButtonWrapper2);

  ChangeCropImageAgainButton = document.createElement("button");
  ChangeCropImageAgainButton.className = "BasicTextButton BasicBoxShadow GreyButton SignInButtonTop Selectable";
  ChangeCropImageAgainButton.innerHTML = window["ChangeImageTxt" + window.CurrentCountryID];
  ButtonWrapper2.append(ChangeCropImageAgainButton);

  SaveCroppedImageButton = document.createElement("button");
  SaveCroppedImageButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
  SaveCroppedImageButton.innerHTML = window["SavedButtonTxt" + window.CurrentCountryID];
  ButtonWrapper2.append(SaveCroppedImageButton);

  // ================================= Upload Image Success =================================
  
  UploadImageSuccessWrapper = document.createElement("div");
  UploadImageSuccessWrapper.className = "FlexContainerBaseAnimate FinalConfirmationWrapper";
  UploadImageSuccessWrapper.id = "UploadImageSuccessWrapper";
  UploadImageSuccessWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
  AllCropContentWrapperContainer.append(UploadImageSuccessWrapper);

  let UploadImageSuccessStepsWrapperFlex = document.createElement("div");
  UploadImageSuccessStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
  UploadImageSuccessWrapper.append(UploadImageSuccessStepsWrapperFlex);

  let UploadImageSuccessCloseButton = document.createElement("img");
  UploadImageSuccessCloseButton.className = "CloseButtonInsidePanel Selectable2";
  UploadImageSuccessCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
  UploadImageSuccessCloseButton.onclick = function()
  {
    window.ClosePanelAnimate(AllCropContentWrapperContainer, BasicBlackBlocker, null);
  }
  UploadImageSuccessStepsWrapperFlex.append(UploadImageSuccessCloseButton);

  let CheckSuccessGreenCircle = document.createElement("img");
  CheckSuccessGreenCircle.className = "CheckSuccessGreenCircle";
  CheckSuccessGreenCircle.src = "/Assets/images/Icon/check-grey-circle.svg";
  UploadImageSuccessWrapper.append(CheckSuccessGreenCircle);

  let UploadImageSuccessMessage = document.createElement("p");
  UploadImageSuccessMessage.className = "RoomHotelNameInsidePanel MarginTextUpDown InterBoldTextFont";
  UploadImageSuccessMessage.innerHTML = window["ChangePhotoSuccessMessage" + window.CurrentCountryID];
  UploadImageSuccessMessage.style="width: fit-content; margin: 0 auto; text-align: center;";
  UploadImageSuccessWrapper.append(UploadImageSuccessMessage);

  let UploadImageSuccessExploreButton = document.createElement("button");
  UploadImageSuccessExploreButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable InputFieldMarginBoth";
  UploadImageSuccessExploreButton.style = "margin-left: auto; margin-right: auto;";
  UploadImageSuccessExploreButton.innerHTML = window["CloseButtonTxt" + window.CurrentCountryID];
  UploadImageSuccessExploreButton.onclick = function()
  {
    window.ClosePanelAnimate(AllCropContentWrapperContainer, BasicBlackBlocker, null);
  }
  UploadImageSuccessWrapper.append(UploadImageSuccessExploreButton);
  

  window.OpenPanelAnimate(AllCropContentWrapperContainer, BasicBlackBlocker);

  // ------------------------------- SET FUNCTION ----------------------------------

  CloseButton1.onclick = function()
  {
    window.ClosePanelAnimate(AllCropContentWrapperContainer, BasicBlackBlocker, null);
  }

  ProfileImageCropperContainer.ondrop = function(event)
  {
    HandleDropImage(event);
  }
  ProfileImageCropperContainer.ondragover = function(event)
  {
    event.preventDefault()
  }
  
  CloseButton2.onclick = function()
  {
    window.MovePanelInsideContainerBack(ImageCropResultWrapper, ImageCropMainWrapper, AllCropContentWrapperContainer);
  }

  AddImageButton.onclick = function()
  {
    ChangeImageButtonClicked();
  }

  ResetImageButton.onclick = function()
  {
    ResetImageButtonClicked();
  }

  RemoveImageButton.onclick = function()
  {
    RemoveCroppedImage();
  }

  ApplyCropButton.onclick = function(event)
  {
    event.preventDefault();
    let ImageCroppedResult = cropper.getCroppedCanvas({}).toDataURL();
    CropResultImage.src = ImageCroppedResult;

    let CropImageBlocker = window.InstantiateLoadingBlocker("CropImageBlocker");
    window.MovePanelInsideContainerNext(ImageCropMainWrapper, ImageCropResultWrapper, AllCropContentWrapperContainer, function(){CropImageBlocker.remove()});

    SaveCroppedImageButton.onclick = function()
    {
      let ImgTemp = document.createElement("img");
      ImgTemp.src = ImageCroppedResult;
      CompressImageToJPGBeforeUpload(ImgTemp, thisuserid, tokenlogin);
    }
  }

  ChangeCropImageAgainButton.onclick = function()
  {
    window.MovePanelInsideContainerBack(ImageCropResultWrapper, ImageCropMainWrapper, AllCropContentWrapperContainer);
  }


  // On Input Change Call This Function ---------------------------------
  ImageCropperInput.addEventListener('change', e =>
  {
    const file = e.target.files[0];
    if (file && ["image/png", "image/jpeg", "image/jpg"].includes(file.type))
    {
      ApplyChangeImageDropInput(e);
    }
  });
  
  cropper = '';
}

// ======================================= ON FILE DROP =============================================

function HandleDropImage(e)
{
    e.preventDefault();

    if(e.dataTransfer.files.length > 0 && ["image/png", "image/jpeg", "image/jpg"].includes(e.dataTransfer.files[0].type))
    {
        ImageCropperInput.files = e.dataTransfer.files;
        ImageCropperInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
}


// ======================================== APPLY CHANGES ========================

function ApplyChangeImageDropInput(event)
{
  ImageFromInputHasChanged(ImageCropperInput); // Change UI After Image Uploaded

  const reader = new FileReader(); // Prepare Reader Image Inputted -------
  reader.onload = event =>
  {
    if(event.target.result)
    {
      let img = document.createElement('img');
      img.id = 'image';
      img.src = event.target.result;

      IMGInputtedDisplayDiv.innerHTML = '';
      IMGInputtedDisplayDiv.appendChild(img);

      cropper = new window.Cropper(img);
    }
  };
  reader.readAsDataURL(event.target.files[0]);
}


function ImageFromInputHasChanged(thisobject) // Update URL And UI After Image Successfuly Uploaded --------------
{
    CropSectionAllElementContainer.style.height = "fit-content";
    FirstTimeUploadImageContainer.style.display = "none";

    let ImageURLValue = thisobject.value;
    URLUploadedText.innerHTML = ImageURLValue;

    AddImageButton.innerHTML = window["ChangeImageTxt" + window.CurrentCountryID];
    RemoveImageButton.className = "BasicTextButton BasicBoxShadow RedButton SignInButtonTop Selectable";
    ResetImageButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
    ApplyCropButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
}

function ChangeImageButtonClicked()
{
    ImageCropperInput.click();
}

function ResetImageButtonClicked()
{
    const ThisFiles = ImageCropperInput.files;
    IMGInputtedDisplayDiv.innerHTML = '';

    if (ThisFiles.length > 0 && (ThisFiles[0].type == "image/png" || ThisFiles[0].type == "image/jpeg" || window.e.dataTransfer.files[0].type == "image/jpg"))
    {
        ImageCropperInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

function RemoveCroppedImage()
{
  ImageCropperInput.value = "";
  IMGInputtedDisplayDiv.innerHTML = '';

  CropSectionAllElementContainer.style.height = "";
  FirstTimeUploadImageContainer.style.display = "";

  URLUploadedText.innerHTML = '-';

  AddImageButton.innerHTML = window["AddImageTxt" + window.CurrentCountryID];
  RemoveImageButton.className = "BasicTextButton BasicBoxShadow RedButton ButtonInvalid SignInButtonTop Selectable";
  ResetImageButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton ButtonInvalid SignInButtonTop Selectable";
  ApplyCropButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight ButtonInvalid PaddingExtendedButton Selectable";

}

function CompressImageToJPGBeforeUpload(thisimage, thisuserid, tokenlogin)
{
  let canvas = document.createElement("canvas");
  canvas.width = thisimage.width;
  canvas.height = thisimage.height;

  let ctx = canvas.getContext("2d");
  ctx.fillStyle = "#f1f1f1";
  ctx.fillRect(0,0,canvas.width,canvas.height);
  ctx.drawImage(thisimage, 0, 0);
  let dataURL = canvas.toDataURL("image/jpeg", 0.85);

  // const base64 = window.getBase64StringFromDataURL(dataURL);
  // //console.log(base64);
  // SaveProfileImageToDatabase(base64, thisuserid, tokenlogin);

  const url = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");

  window.getImgURL(url, (imgBlob)=>
  {
    let fileName = 'usernewphoto.jpg'
    let file = new File([imgBlob], fileName,{type:"image/jpeg", lastModified:new Date().getTime()}, 'utf-8');
    let container = new DataTransfer();

    container.items.add(file);

    if(container.files[0].size != 0) // send Image To Database --------------
    {
      SaveProfileImageToDatabase(container.files[0], thisuserid, tokenlogin);
    }
  })
}

function SaveProfileImageToDatabase(thisfile, thisuserid, tokenlogin)
{
  window.event.preventDefault();

  if(thisfile)
  {
    let SaveImageBlocker = window.InstantiateLoadingBlocker("SaveImageBlocker");
    WarningUploadImageContainer.style.display = "none";
    (async () =>
    {
      let formData = new FormData();
      formData.append('profile_picture', thisfile);
      formData.append('token', tokenlogin);
      await window.getBrowserData(formData);

      
      let UploadProfileImageURL = "/v2/profile/" + thisuserid + "/pict";
      // let UploadProfileImageURL = "/v2/debug-upload/";

      window.CallApiAxios({
          method: "POST",
          url: UploadProfileImageURL,
          data: formData,
          convertFormData: false
      }).then(res =>
      {
        //console.log(UploadProfileImageURL);
        //console.log(res);

        if(res.status == 200)
        {
          let UploadImageStatus = res.data;

          if(UploadImageStatus.success == true && UploadImageStatus.message == "Profile picture uploaded successfully")
          {
            if(sessionStorage.getItem("U_Ping_INFO") != null)
                sessionStorage.removeItem("U_Ping_INFO");
            window.CheckUserInfoExist(false);
            window.MovePanelInsideContainerNext(ImageCropResultWrapper, UploadImageSuccessWrapper, AllCropContentWrapperContainer, function(){SaveImageBlocker.remove()});
          }
          else
          {
            WarningUploadImageContainer.style.display = "";
            WarningUploadImageText.innerHTML = window["ChangePhotoErrorMessage" + window.CurrentCountryID];
            SaveImageBlocker.remove();
          }
        }
      })
      .catch(err =>
      {
          //console.error(err);
          SaveImageBlocker.remove();
          // WarningUploadImageContainer.style.display = "";
          // WarningUploadImageText.innerHTML = window["ChangePhotoErrorMessage" + window.CurrentCountryID];
      });

    })();
  }
  else
  {
    alert(window["FileNotValidOrSizeInsufficientTxt" + window.CurrentCountryID]);
  }
}